import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/imgs/inserts/afex-logo.png'
import _imports_1 from '../assets/imgs/inserts/mirabella-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-a46ddcc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Clients", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "How Derivitec works for us.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Clients", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "columns" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "half" }, "Derivitec works with a diverse set of companies, from hedge funds to foreign exchanage remittance companies. Read about how they use Derivitec, in their own words.")
], -1))
const _hoisted_5 = { class: "grid" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "AFEX logo"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Mirabella logo"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "name" }, "Multi-strategy Hedge Fund", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subline" }, "Hong Kong", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_panel = _resolveComponent("panel")!
  const _component_client_box = _resolveComponent("client-box")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_panel, {
      class: "head bg-right-sm",
      bg: true
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_panel, null, {
      default: _withCtx(() => [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/clients/afex" }, {
              default: _withCtx(() => [
                _createVNode(_component_client_box, { company: "AFEX" }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: { name: 'Mirabella' } }, {
              default: _withCtx(() => [
                _createVNode(_component_client_box, { company: "Mirabella" }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: { name: 'mshf' } }, {
              default: _withCtx(() => [
                _createVNode(_component_client_box, null, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _hoisted_9
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}